import React, { useState } from "react";

export default function Krushi() {
  const [tab, setTab] = useState("prastavana");

  const tabs = {
    prastavana: "प्रस्तावना",
    yojana: "योजना",
    patrate: "पात्रता",
    biogas: "बायोगॅस योजना",
    sesfund: "SES फंड",
    sampark: "संपर्क",
  };

  const tabStyle = (t) => ({
    padding: "10px 20px",
    cursor: "pointer",
    borderBottom: tab === t ? "3px solid #2E7D32" : "2px solid transparent",
    fontWeight: tab === t ? "700" : "500",
    color: tab === t ? "#1B5E20" : "#444",
  });

  return (
    <div style={{ padding: "20px", background: "#f2f2f2" }}>
      {/* PAGE TITLE */}
      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <img
          src="/images/farmer.png"
          alt="dept"
          style={{ width: "70px", height: "70px" }}
        />
        <h1 style={{ fontSize: "30px", color: "#1B5E20" }}>
          कृषी विभाग – पंचायत समिती, बल्लारपूर (जि. चंद्रपूर)
        </h1>
      </div>

      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: "20px",
          marginTop: "25px",
          background: "white",
          padding: "10px",
          borderRadius: "10px",
          overflowX: "auto",
        }}
      >
        {Object.keys(tabs).map((key) => (
          <div key={key} style={tabStyle(key)} onClick={() => setTab(key)}>
            {tabs[key]}
          </div>
        ))}
      </div>

      {/* CONTENT BOX */}
      <div
        style={{
          marginTop: "20px",
          background: "white",
          padding: "20px",
          borderRadius: "10px",
          lineHeight: "1.7",
        }}
      >
        {/* प्रस्तावना */}
        {tab === "prastavana" && (
          <>
            <h2>विभागाची प्रस्तावना</h2>
            <p>
              भारत हा कृषिप्रधान देश असून कृषी हा अर्थव्यवस्थेचा कणा आहे. वाढत्या
              लोकसंख्येमुळे कृषी उत्पादनात वाढ होणे अत्यावश्यक आहे.
            </p>
            <p>
              शेतकऱ्यांना खते, बियाणे, किटकनाशके माफक दरात मिळावीत, आधुनिक तंत्रज्ञान
              पोहोचावे आणि सामाजिकदृष्ट्या दुर्बल शेतकऱ्यांना सिंचन व सुविधा
              मिळाव्यात हे उद्दिष्ट ठेवून पंचायत समिती बल्लारपूर (जि. चंद्रपूर) येथील
              कृषी विभाग कार्यरत आहे.
            </p>
          </>
        )}

        {/* योजना */}
        {tab === "yojana" && (
          <>
            <h2>योजना</h2>

            <h3>१) डॉ. बाबासाहेब आंबेडकर कृषी स्वावलंबन योजना</h3>
            <h3>२) बिरसा मुंडा कृषी क्रांती योजना</h3>

            <h3>अनुदान मर्यादा</h3>
            <ul>
              <li>नवीन सिंचन विहीर – ₹4,00,000</li>
              <li>जुनी विहीर दुरुस्ती – ₹1,00,000</li>
              <li>इनवेल बोअरींग – ₹40,000</li>
              <li>पंप संच – ₹40,000</li>
              <li>शेततळे प्लॉस्टीक अस्तरीकरण – ₹2,00,000</li>
              <li>ठिंबक सिंचन – ₹97,000</li>
              <li>तुषार सिंचन – ₹47,000</li>
              <li>सोलार पंप – ₹50,000</li>
              <li>HDPVC पाईप – ₹50,000</li>
              <li>यंत्रसामुग्री – ₹50,000</li>
              <li>परसबाग – ₹5,000</li>
            </ul>
          </>
        )}

        {/* पात्रता */}
        {tab === "patrate" && (
          <>
            <h2>लाभार्थी पात्रतेच्या अटी</h2>
            <ul>
              <li>आंबेडकर योजनेसाठी — अनुसूचित जाती/नवबौद्ध शेतकरी</li>
              <li>बिरसा मुंडा योजनेसाठी — अनुसूचित जमातीचे शेतकरी</li>
              <li>जातीचा दाखला आवश्यक</li>
              <li>विहीर घटकासाठी ०.४० ते ६ हेक्टर जमीन</li>
              <li>इतर घटकासाठी किमान ०.२० हेक्टर जमीन</li>
              <li>७/१२, ८ अ उतारा आवश्यक</li>
              <li>बँक खाते आधार लिंक</li>
              <li>ग्रामसभेची शिफारस</li>
              <li>दिव्यांग, BPL लाभार्थ्यांना प्राधान्य</li>
            </ul>

            <p>
              अर्ज करासाठी अधिकृत संकेतस्थळ:  
              <b>https://mahadbt.maharashtra.gov.in/farmer/login</b>
            </p>
          </>
        )}

        {/* बायोगॅस योजना */}
        {tab === "biogas" && (
          <>
            <h2>राष्ट्रीय बायोगॅस व सेंद्रिय खत व्यवस्थापन कार्यक्रम</h2>

            <h3>महत्व</h3>
            <ul>
              <li>स्वच्छ इंधन</li>
              <li>सेंद्रिय खत निर्मिती</li>
              <li>धूरमुक्त वातावरण</li>
              <li>इंधन बचत</li>
            </ul>

            <h3>अनुदान</h3>
            <ul>
              <li>सर्वसाधारण – ₹14,350</li>
              <li>SC/ST – ₹22,000</li>
              <li>शौचालय जोडणी – ₹1,600</li>
            </ul>

            <h3>पात्रता</h3>
            <ul>
              <li>किमान ४ जनावरे</li>
              <li>स्वतःची जागा</li>
              <li>शेतकरी असण्याचे बंधन नाही</li>
            </ul>
          </>
        )}

        {/* SES FUND */}
        {tab === "sesfund" && (
          <>
            <h2>SES फंड – ५०% अनुदानावर साहित्य पुरवठा</h2>
            <ul>
              <li>प्लास्टिक ताडपत्री</li>
              <li>पाईप संच</li>
              <li>कृषी अवजारे</li>
              <li>अनुसूचित जाती/जमाती, दिव्यांग व सर्वसामान्य शेतकरी पात्र</li>
            </ul>

            <h3>कागदपत्रे</h3>
            <ul>
              <li>अर्ज</li>
              <li>७/१२, ८ अ उतारा</li>
              <li>आधार कार्ड</li>
              <li>बँक खाते</li>
              <li>खरेदी साहित्याचे फोटो</li>
            </ul>
          </>
        )}

        {/* संपर्क */}
        {tab === "sampark" && (
          <>
            <h2>संपर्क</h2>
            <p>
              कृषी अधिकारी, पंचायत समिती बल्लारपूर  
              जि. चंद्रपूर
            </p>
          </>
        )}
      </div>
    </div>
  );
}
